const Icon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.8658 11.7553H26.1457"
        stroke="#FFD029"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.5526 16.6372H20.5642"
        stroke="#FFD029"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.0058 16.6372H15.0173"
        stroke="#FFD029"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.44736 16.6372H9.45894"
        stroke="#FFD029"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.5526 21.4953H20.5642"
        stroke="#FFD029"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.0058 21.4953H15.0173"
        stroke="#FFD029"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.44736 21.4953H9.45894"
        stroke="#FFD029"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.0546 2.5V6.61347"
        stroke="#FFD029"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.95688 2.5V6.61347"
        stroke="#FFD029"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.2978 4.474H9.7137C6.04284 4.474 3.75 6.51892 3.75 10.2778V21.5898C3.75 25.4078 6.04284 27.5 9.7137 27.5H20.2863C23.9687 27.5 26.25 25.4433 26.25 21.6844V10.2778C26.2615 6.51892 23.9803 4.474 20.2978 4.474Z"
        stroke="#FFD029"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Icon;
